<template>
    <el-dialog
        v-if="model === 'Dialog'"
        :close-on-click-modal="false"
        class="stepDialog"
        :before-close="before_close"
        @close="close"
        :title="title"
        :visible.sync="dialogVisble"
        size="small">
        <slot name="step-main"></slot>
        <slot name="step-footer" slot="footer"></slot>
    </el-dialog>
    <div class="stepDialog" v-else>
        <slot name="step-main"></slot>
        <slot name="step-footer"></slot>
    </div>
</template>
<script>
export default {
  name: 'stepLayout',
  props: {
    model: {
      type: String,
      default: 'Dialog',
    },
    title: String,
    visible: Boolean,
    before_close: Function,
    close: Function,
  },
  data() {
    return {
      dialogVisble: this.visible, // 传递开关初始值
    };
  },
  watch: {
    visible(val) {
      // 运用sync修饰符语法糖，触发v-on update事件
      this.$emit('update:visible', val);
      this.dialogVisble = val;
    },
  },
};
</script>
